module.exports = __webpack_public_path__ + "static/media/salida_icono.b4960fe6.svg";